module.exports = __webpack_public_path__ + "img/small_27 Orzech.d008c0f1.png";